import { IStorageStrategyResource } from './storage-strategy.types';
import { StorageAdapter } from './storage-adapter';

import { SessionStorageAdapter } from './adapters/session-storage.adapter';
import { CookiesAdapter } from './adapters/cookies.adapter';

import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';

export type StorageType = 'sessionStorage' | 'cookies';

@Injectable({ providedIn: 'root' })
export class StorageStrategyResource implements IStorageStrategyResource {
  constructor(private cookieService: CookieService) {}

  create(eventType: StorageType): StorageAdapter {
    switch (eventType) {
      case 'sessionStorage':
        return new SessionStorageAdapter();
      case 'cookies':
        return new CookiesAdapter(this.cookieService);
      default:
        throw Error('Storage not implemented');
    }
  }
}
